export default __webpack_public_path__ + "static/messi-d40729e6c3893a0438496444cd9d701c.png";